import * as fromReducer from './device-information.reducer';
import { DeviceInformation, DeviceInformationState } from './device-information.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DevicesRouterStoreSelectors } from '../router';

export const selectDeviceInformationState = createFeatureSelector<DeviceInformationState>(
  fromReducer.deviceInformationFeatureKey
);

export const selectDeviceInformation = createSelector(
  selectDeviceInformationState,
  fromReducer.selectAllDeviceInformation
);

export const selectDeviceInformationEntities = createSelector(
  selectDeviceInformationState,
  fromReducer.selectDeviceInformationEntities
);

export const selectDeviceInformationIds = createSelector(
  selectDeviceInformationState,
  fromReducer.selectDeviceInformationIds
);

export const selectDeviceInformationByUdid = createSelector(
  selectDeviceInformation,
  DevicesRouterStoreSelectors.selectUdid,
  (devices: DeviceInformation[], udid: string) => devices.find((device) => device.udid === udid)
);
